import { __decorate, __metadata } from "tslib";
import { injectable } from "inversify";
import { LocalizationOptionsStore } from "./options/LocalizationOptions";
import { UserLocalizationConfigStore } from "./user/UserLocalizationConfigStore";
import { ReadonlyStore } from "../store";
let LocalizationContext = class LocalizationContext extends ReadonlyStore {
    constructor(optionsStore, userConfigStore) {
        super({
            defaultCurrency: optionsStore.value.defaultCurrency,
            currentCurrency: userConfigStore.value.selectedCurrency ?? optionsStore.value.defaultCurrency,
            defaultLocale: optionsStore.value.defaultLocale,
            currentLocale: optionsStore.value.wellKnownLocales.find(l => userConfigStore.value.selectedLocale && l.equals(userConfigStore.value.selectedLocale)) ?? optionsStore.value.defaultLocale,
            wellKnownLocales: optionsStore.value.wellKnownLocales,
        });
        this.optionsStore = optionsStore;
        this.userConfigStore = userConfigStore;
        if (userConfigStore.value.selectedLocale && !this.value.currentLocale.equals(userConfigStore.value.selectedLocale)) {
            userConfigStore.setCurrentLocale(this.value.currentLocale);
        }
    }
    get options() {
        return this.optionsStore;
    }
    get user() {
        return this.userConfigStore;
    }
    registerListeners() {
        this.optionsSubscription ??= this.optionsStore.value$.subscribe(options => {
            this.mutate(state => {
                state.defaultLocale = options.defaultLocale;
                state.wellKnownLocales = options.wellKnownLocales;
                return state;
            });
        });
        this.userConfigSubscription ??= this.userConfigStore.value$.subscribe(config => {
            const currentLocale = this.value.currentLocale;
            const nextLocale = config.selectedLocale;
            const currentCurrency = this.value.currentCurrency;
            const nextCurrency = config.selectedCurrency;
            this.mutate(state => {
                if (nextLocale) {
                    state.currentLocale = nextLocale;
                }
                if (nextCurrency) {
                    state.currentCurrency = nextCurrency;
                }
                return state;
            });
        });
    }
    setCurrentLocale(locale) {
        this.userConfigStore.setCurrentLocale(locale);
    }
    setCurrentCurrency(currency) {
        this.userConfigStore.setCurrentCurrency(currency);
    }
};
LocalizationContext = __decorate([
    injectable(),
    __metadata("design:paramtypes", [LocalizationOptionsStore,
        UserLocalizationConfigStore])
], LocalizationContext);
export { LocalizationContext };
//# sourceMappingURL=context.js.map